<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vNW3yR/tc-custom/9781590203828.jpg?1726455547978" alt="This image is the cover for the book Tears of Autumn, Paul Christopher Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tears of Autumn, Paul Christopher Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A rogue agent crisscrosses the globe to investigate the assassination of JFK in this acclaimed spy novel by the acclaimed author of  <i>The Miernik Dossier</i>.</b><br/><br/> When President Kennedy is shot in Dallas, the nation is shocked and mystified. But American spy Paul Christopher has a different perspective. He believes he knows who arranged the assassination and why. But if his theory is correct, it would destroy the dead president’s image and endanger vital foreign policy. Christopher is therefore ordered to end his investigation.<br/><br/> Determined to uncover the truth, Christopher resigns from the Agency and embarks on a quest that takes him from Paris to Rome, Zurich, the Congo, and Saigon. Threatened by Kennedy’s assassins and by his own government, Christopher follows the scent of his suspicion into the dark heart of a geopolitical conspiracy.<br/><br/><i>The Tears of Autumn</i> is an incisive study of power and a brilliant commentary on the force of illusion, the grip of superstition, and the overwhelming strength of blood and family in the affairs of a nation. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles McCarry
      </h2>
      
      <p class="authorDescription body article">A former operative for the CIA, Charles McCarry (b. 1930) is America&rsquo;s most revered author of espionage fiction. Born in Massachusetts, McCarry began his writing career in the army, as a correspondent for<i> Stars and Stripes</i>. In the 1950s he served as a speechwriter for President Eisenhower before taking a post with the CIA, for which he traveled the globe as a deep cover operative. He left the Agency in 1967, and set about converting his experiences into fiction.&#160;His first novel, <i>The Miernik Dossier </i>(1971), introduced Paul Christopher, an American spy who struggles to balance his family life with his work. McCarry has continued writing about Christopher and his family for decades, producing ten novels in the series to date. A former editor-at-large for <i>National Geographic</i>, McCarry has written extensive nonfiction, and continues to write essays and book reviews for various national publications. <i>Ark</i> (2011) is his most recent novel. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c46fddb8